import { createAsyncThunk } from "@reduxjs/toolkit";
import { Client } from "@helpers/helpers";
import { API_METHOD } from "@constants/constants";
import { url } from "@constants/url-constants";

export const getFeedbackList = createAsyncThunk(
  "feedback/list",
  async ({ pageCount, limit, search }) => {
    const response = await Client(
      API_METHOD.GET,
      url.feedbacks +
        `?page=${pageCount}&limit=${limit}&deleted_at=1&q=${
          !search ? "" : search
        }`
    );
  
    return response.data;
  }
);

export const addFeedBack = createAsyncThunk(
  "feedback/add",
  async (data, { rejectWithValue }) => {
    try {
      const response = await Client(API_METHOD.POST, url.feedbacks, data);
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

//fetch

export const editFeedback = createAsyncThunk(
  "feedback/edit",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await Client(
        API_METHOD.PUT,
        url.feedbacks + `/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

export const getFeedbackCount = async () =>{
  const response = await Client(API_METHOD.GET, url.feedbacks)
  return response.data?.data?.item?.total_count;
}

export const getFeedback = createAsyncThunk("feedback/one", async (id) => {
  const response = await Client(API_METHOD.GET, url.feedbacks + `/${id}`);
  return response.data;
});

